

<mat-card *ngIf="showReferralCard" class="referal-card">
    <mat-card-header>
        <mat-card-title>Have a Referral Code?</mat-card-title>
    </mat-card-header>
    <mat-card-content (click)="handleReferralCodeClick()">
        <a mat-stroked-button  id="referral-code-link" href="https://fitnesspassport-referrals.freshdesk.com/support/tickets/new" target="_blank">Enter Referral Code</a>
    </mat-card-content>
</mat-card>



